
export interface IAntiBodyTransactionDetails {
    orderId: number,
    recipientCenter: string,
    recipientAlias: string,
    requested: string,
    completed: string
}
